import { Env } from '@app/core/interfaces/env.interface';
import { environment as maximProdEnv } from './environment.prod-maxim';
import { Store } from '@app/shared/modules/mobile-badge/enums/store.enum';
import { AxiomMapRegion } from '@axiom/material-components/kit/map';

export const environment: Env = {
  ...maximProdEnv,
  apiUrl: 'https://api.taximaxim.ir/client/v1',
  stores: {
    [Store.AppStore]: 'https://apps.apple.com/app/id1487634592',
    [Store.GooglePlay]:
      'https://play.google.com/store/apps/details?id=com.orderacar',
    [Store.AppGallery]:
      'https://appgallery.cloud.huawei.com/marketshare/app/C100093035',
  },
  site: 'https://taximaxim.ir',
  mapConfig: {
    ...maximProdEnv.mapConfig,
    region: AxiomMapRegion.Ir,
  },
};
